// extracted by mini-css-extract-plugin
module.exports = {"container":"TutorialDashboard_container__38i_X","cardItem":"TutorialDashboard_cardItem__hTrCu"};